import { z } from 'zod';

export const WebSocketEnvelopeSchema = z.object({
  type: z.string(),
  data: z.unknown().optional(),
  employee_id: z.number().optional(),
  meta: z.record(z.unknown()).optional(),
});

export type WebSocketEnvelope = z.infer<typeof WebSocketEnvelopeSchema>;
